import { useEffect, useState } from 'react';
export const Footer = (props: any) => {
  return (
    <div className="admin-footer py-4">
      <div className="row">
        <div className="col-6 text-start">
          COPYRIGHT © 2023 <a href="#">PANDORA</a>
        </div>
        <div className="col-6 text-end">
          Powered by: <strong>Manu Tech Innovation</strong>
        </div>
      </div>
    </div>
  );
};
